export default __webpack_public_path__ + "static/media/IMG16.ff891b65.jpg";